import { LAYOUTS, ModalAlignmentEnum } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { WIDGET } from "@voltmoney/schema";
import { heightMap } from "../../configs/height";
import { ACTION } from "./types";
import { DownloadHoldingData, DownloadSoaData, navigateCustomerJourney, navigateToCustomerScreen } from "./action";
import { isMobile } from "../../configs/utils";
import { onShareLinkWithCustomer } from "../activeCustomer/actions";
export const template = (height, currentActiveTabIndex, customerViewData, creditId, numberOfFilterApplied, filterObj, currentPageCustomer) => {
    return {
        layout: {
            id: ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN,
            type: LAYOUTS.MODAL,
            style: {
                isPartnerPlatform: true,
                height: isMobile() ? heightMap[ROUTE.PARTNER_VIEW_DETAIL_LEAD] : heightMap[ROUTE.CHECK_LIMIT_INFO],
                alignment: isMobile() ? ModalAlignmentEnum.BOTTOM : ModalAlignmentEnum.RIGHT
            },
            widgets: [{
                    id: 'customerViewDetail',
                    type: WIDGET.CUSTOMER_VIEW_DETAILS_SCREEN_DC,
                }],
        },
        datastore: {
            customerViewDetail: {
                height: isMobile() ? heightMap[ROUTE.PARTNER_VIEW_DETAIL_LEAD] : height,
                customerViewData,
                currentActiveTabIndex,
                numberOfFilterApplied,
                filterObj,
                currentPageCustomer,
                holdingLoading: false,
                soaLoading: false,
                navigateCustomerScreen: {
                    type: ACTION.NAVIGATE_CUSTOMER_SCREEN,
                    routeId: ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN,
                    payload: {},
                },
                downloadSoaAction: {
                    type: ACTION.DOWNLOAD_SOA_DETAILS,
                    routeId: ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN,
                    payload: { currentActiveTabIndex, creditId, customerViewData },
                },
                downloadHoldingAction: {
                    type: ACTION.DOWNLOAD_HOLDING_DETAILS,
                    routeId: ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN,
                    payload: { currentActiveTabIndex, creditId, customerViewData },
                },
                navigateToShareLink: {
                    type: ACTION.SHARE_LINK_REF,
                    routeId: ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN,
                    payload: {},
                },
                navigateToCustomerJourney: {
                    type: ACTION.START_JOURNEY,
                    routeId: ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN,
                    payload: {},
                }
            },
        },
    };
};
export const customerViewDetailScreen = {
    onLoad: async ({ network, getHeight }, { currentActiveTabIndex, customerViewData, numberOfFilterApplied, filterObj, currentPageCustomer }) => {
        const creditId = customerViewData?.creditId;
        return Promise.resolve(template(getHeight(), currentActiveTabIndex, customerViewData, creditId, numberOfFilterApplied, filterObj, currentPageCustomer));
    },
    actions: {
        [ACTION.NAVIGATE_CUSTOMER_SCREEN]: navigateToCustomerScreen,
        [ACTION.DOWNLOAD_SOA_DETAILS]: DownloadSoaData,
        [ACTION.DOWNLOAD_HOLDING_DETAILS]: DownloadHoldingData,
        [ACTION.SHARE_LINK_REF]: onShareLinkWithCustomer,
        [ACTION.START_JOURNEY]: navigateCustomerJourney,
    },
};
